export default __webpack_public_path__ + "static/media/IMG_b87ec0.f95b0677.jpg";